module.exports = __webpack_public_path__ + "3f63ed306b25ff9aaf8e9d66850a373e.MP3";